
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexIwD5XwsAQ0412nlSe98tOkg_HJF7Tep8P8etzmpjEo8Meta } from "/tmp/build_06f73642/pages/app/me/index.vue?macro=true";
import { default as meMnIRIgDOyfv4Vl_45xnq7ge7LcemoYbs7jC0JdbKp4XgAMeta } from "/tmp/build_06f73642/pages/app/me.vue?macro=true";
import { default as map5_b8grYcoPL0Fhwq04qPekM_452NgoNkwDU9o8HEhazlYMeta } from "/tmp/build_06f73642/pages/app/map.vue?macro=true";
import { default as postaB85D2X8NtaasB6Q7srufyqj8yTy9bL_455vInW6WFAR0Meta } from "/tmp/build_06f73642/pages/app/feed/post.vue?macro=true";
import { default as indexzFxvZtqgRBWY_45DQwTeL1rtq4VOc0FesXGRStyh6qM8MMeta } from "/tmp/build_06f73642/pages/app/feed/index.vue?macro=true";
import { default as _91type_93vyHbFrrY_45OZHS23N_PCADcZwUwvx3jz0_hHPZq_45GekoMeta } from "/tmp/build_06f73642/pages/app/feed/[type].vue?macro=true";
import { default as feedlHMSRfntoBj_456YywSKFYPAT65Dw3nRfaJF0f0t2S_45KcMeta } from "/tmp/build_06f73642/pages/app/feed.vue?macro=true";
import { default as indexPBpwQqiIqihhOm_45OMgLYmVkBjt5SO_MGI8wbY3j4d8MMeta } from "/tmp/build_06f73642/pages/app/index.vue?macro=true";
import { default as eulaeSOwiwjIGA9RRIEsjejrgt3Hc3pu4E6hqlNbIKt2dgIMeta } from "/tmp/build_06f73642/pages/main/eula.vue?macro=true";
import { default as indexJl_JN_oK6sb1R012m0g1Ij95xU6m_SuMjL8vec4i2VQMeta } from "/tmp/build_06f73642/pages/app/groups/index.vue?macro=true";
import { default as editcbS5TFO_45EDA0TuTl1jW6DhNmS4xVstwzcqIt6DWEzGQMeta } from "/tmp/build_06f73642/pages/app/groups/[slug]/edit.vue?macro=true";
import { default as aboutxCQc9Z2zRdx_45WmcSvHC6KNNkEAAYth_45cnyhljRUbaGsMeta } from "/tmp/build_06f73642/pages/app/groups/[slug]/about.vue?macro=true";
import { default as indexQzjJv5FXda7vH0SE_1Mqtaavm2YY1smBh6PgqwNt0lMMeta } from "/tmp/build_06f73642/pages/app/groups/[slug]/index.vue?macro=true";
import { default as eventsDY6FMQ7Hr8Kjue3UWHN452Sd4dnqHohSk5XsamzfEAgMeta } from "/tmp/build_06f73642/pages/app/groups/[slug]/events.vue?macro=true";
import { default as membersLRIMWiPbG6qU8Ia9jRkkfnM16sbO6vQSZ5ZSTXDkSkgMeta } from "/tmp/build_06f73642/pages/app/groups/[slug]/members.vue?macro=true";
import { default as conversationsfD46MLB9MtJcVMhTFfXgBnYnTS9nOdgSTItRPqHm6T4Meta } from "/tmp/build_06f73642/pages/app/groups/[slug]/conversations.vue?macro=true";
import { default as _91slug_93oRdGCQLztwxnBecm9XMlV7tC3LR4g9Vvr_45Gw5FnioagMeta } from "/tmp/build_06f73642/pages/app/groups/[slug].vue?macro=true";
import { default as createx_45QlrnCTOJgO5ZXs7nxbZdzpsXeyGCdhknJAT2wSy2kMeta } from "/tmp/build_06f73642/pages/app/groups/create.vue?macro=true";
import { default as groups4ob2JaLhRrU3m4NwzWrKZEYzqgiLMCfQPzeDUKDgNfcMeta } from "/tmp/build_06f73642/pages/app/groups.vue?macro=true";
import { default as indext_4dnXTLqqGcpCLEHOAglsS3SQoHsnETptG_KmQI1_cMeta } from "/tmp/build_06f73642/pages/app/params/index.vue?macro=true";
import { default as accountWIlQ_9TKL12AKUxsaLAZkBXShOigbgAYoq0UEL7oqlYMeta } from "/tmp/build_06f73642/pages/app/params/account.vue?macro=true";
import { default as transactionsg7LuREdwi1yH4oX0S_45MllPwUaG5Lja610gvo161ZkIAMeta } from "/tmp/build_06f73642/pages/app/params/transactions.vue?macro=true";
import { default as paramslpxSzEsWMe_450fJbQxK_tuGydBUct4iKhFfOAcVEKBpQMeta } from "/tmp/build_06f73642/pages/app/params.vue?macro=true";
import { default as indexrMNJ7O08o4K0grJ6_45zfuym5WiTaN1GoP3k5gvIhXjKUMeta } from "/tmp/build_06f73642/pages/main/index.vue?macro=true";
import { default as pressF76SmTrnWrU3PPCv8ir_45qu1P8x9rpcePAn5G8dE4tYYMeta } from "/tmp/build_06f73642/pages/main/press.vue?macro=true";
import { default as codesSvWMc3jTgLL21N5lcW_45QaIMSRst_J4QyuSciYu98_45DoMeta } from "/tmp/build_06f73642/pages/admin/codes.vue?macro=true";
import { default as indexfItK3PYyGYWyyqNmTRpnMoqkp8JysIgmu9_45N8SklnRwMeta } from "/tmp/build_06f73642/pages/admin/index.vue?macro=true";
import { default as indexvQp6R9J5RRYKoiiSXHlSG7NgMjac2GGwYR5Bqetcy6kMeta } from "/tmp/build_06f73642/pages/app/hangout/index.vue?macro=true";
import { default as agendaqXFkiLTCqtyccP1SZGhmJNmLhL5By2Z_ofswMFNoriYMeta } from "/tmp/build_06f73642/pages/app/hangout/agenda.vue?macro=true";
import { default as meetupstULUCr06DXu1H6Oo4xERo9fAV7CPuaNR6nvl4PiOcZwMeta } from "/tmp/build_06f73642/pages/app/hangout/meetups.vue?macro=true";
import { default as organizePP3XsxgSnm87UcePbTx4FdKilQVWIlv9OwQXmsrnNqAMeta } from "/tmp/build_06f73642/pages/app/hangout/organize.vue?macro=true";
import { default as hangoutSHV0q_45qHoJKnAgDBfxJkcT6lF4fbGbWVpfbh_zhDnCoMeta } from "/tmp/build_06f73642/pages/app/hangout.vue?macro=true";
import { default as charteLudSdpnZFgIYPS1OcxrmMPZYYIUXXqDQvDQ2fKSzbbIMeta } from "/tmp/build_06f73642/pages/main/charte.vue?macro=true";
import { default as francepCdqAsrhUFZ3RcM6gqoXONgX_sC0WQdmaTxZgw34pCwMeta } from "/tmp/build_06f73642/pages/main/france.vue?macro=true";
import { default as themesa0UtoVFiH7kaHFZDwoz1_zWCwobssx9PVz_45inAGsSPIMeta } from "/tmp/build_06f73642/pages/admin/themes.vue?macro=true";
import { default as indexsnADb6oNqgax9D_45o7yrtdh9YsZw6SMBthmPHJp69jf8Meta } from "/tmp/build_06f73642/pages/app/insiders/index.vue?macro=true";
import { default as suggestionsHPYTd08S5qHGG3xoeY_45OpEqLjg6Ns1BIvTQya01k2wIMeta } from "/tmp/build_06f73642/pages/app/insiders/suggestions.vue?macro=true";
import { default as insidersKL_45MMN1kj5r02eYmpifuQbArSiIysoFaY3GoQR6rQogMeta } from "/tmp/build_06f73642/pages/app/insiders.vue?macro=true";
import { default as messagesJ1TK2biZX_45q2hjzGH7znPd0IsyB1H_4552_45rxSVintGkUMeta } from "/tmp/build_06f73642/pages/app/messages.vue?macro=true";
import { default as privacytm2SObd_bWtwmDzNeniGftpS8b3LCR7q8HRRLk4UsPoMeta } from "/tmp/build_06f73642/pages/main/privacy.vue?macro=true";
import { default as trainerl4oxkpqQAP1o4QGh7CLplUNdxJzv0G06Kh_45k3YF0a40Meta } from "/tmp/build_06f73642/pages/admin/trainer.vue?macro=true";
import { default as indexThqkcQxwZiG8A5wpaDO2qMIQ2xsr81UR9zdGefBoAGsMeta } from "/tmp/build_06f73642/pages/app/community/index.vue?macro=true";
import { default as searchxSwYH92gkz1ZJbleh6oc7zMreDCNaqFLCVMn0mzt2MgMeta } from "/tmp/build_06f73642/pages/app/community/search.vue?macro=true";
import { default as bestiesRRS8RQSGq9UydhJPWsjbwVH_nhL3kIpU1JK0y3gjrisMeta } from "/tmp/build_06f73642/pages/app/community/besties.vue?macro=true";
import { default as indexU3UXnFeB58LGqGY2j8XDGHvgOHt453OMFIwEarNHNFcMeta } from "/tmp/build_06f73642/pages/app/community/[type]/index.vue?macro=true";
import { default as communityt7ILxyDDMo82dEukd9JfSdAt_A9UJxEJVxD0CocHw3IMeta } from "/tmp/build_06f73642/pages/app/community.vue?macro=true";
import { default as index_3cNWQzr3Ex6Gbo3DxNXIH03KUxg77Qo1pwcCvU_9GoMeta } from "/tmp/build_06f73642/pages/app/auth/index.vue?macro=true";
import { default as aboutKum54gU7wONDeB3GfZcxDvyBTHb8_x4nJoqFlOD30ycMeta } from "/tmp/build_06f73642/pages/app/onboarding/about.vue?macro=true";
import { default as emailx1W_45FI9USnoMiB_45fL9dS0OeLjaNcitLrEHEjZ2RIBRIMeta } from "/tmp/build_06f73642/pages/app/onboarding/email.vue?macro=true";
import { default as goalslyReoBG0NGvHx03q_45blL_teCc_9ZV70Hj3uieA_ZgFoMeta } from "/tmp/build_06f73642/pages/app/onboarding/goals.vue?macro=true";
import { default as indexAasrqmQ0roI14GVdJhu4jZhf_6w5R_45a9RwBpvtIYjecMeta } from "/tmp/build_06f73642/pages/app/onboarding/index.vue?macro=true";
import { default as phone7HeL5_fbL8DY8eHGQ_2yVh3_EiLsGF6uKFZgSgvU6uIMeta } from "/tmp/build_06f73642/pages/app/onboarding/phone.vue?macro=true";
import { default as groupskdbgHOIFqg_45YLReOYFKqKCbgUK6MsBu3pMMKbwYinyIMeta } from "/tmp/build_06f73642/pages/app/onboarding/groups.vue?macro=true";
import { default as searchhn9hPyOUGqW6QtpbpRlrugbAdpluYMUOIFIkTxS2AGUMeta } from "/tmp/build_06f73642/pages/app/onboarding/search.vue?macro=true";
import { default as charter2X4ogMMZms1yY2wqPGdlpd_SJRJE5KvVzBViONTmSDAMeta } from "/tmp/build_06f73642/pages/app/onboarding/charter.vue?macro=true";
import { default as loadingyLEdbXm6WiC3eSY7k_lX9z2oUaGsFUZT_45z57RubUuqsMeta } from "/tmp/build_06f73642/pages/app/onboarding/loading.vue?macro=true";
import { default as profile36QSkDYMX7174zP9snOf60D0mlmfAApLinX6lqOQMdUMeta } from "/tmp/build_06f73642/pages/app/onboarding/profile.vue?macro=true";
import { default as identityeJ44ZUDJ2HOgUxnPeDSp_45Oa4CjCkCty7w_45tsbDq2b9QMeta } from "/tmp/build_06f73642/pages/app/onboarding/identity.vue?macro=true";
import { default as profiles1XmGizLhrdVZu40MTSy_Xu8GMQdKtMS8kT3yDDS0sL4Meta } from "/tmp/build_06f73642/pages/app/onboarding/profiles.vue?macro=true";
import { default as membership2a6yBDQBY0_45E4y60sixgC8JaXdLzhOIR2jIIvt2jFs8Meta } from "/tmp/build_06f73642/pages/app/onboarding/membership.vue?macro=true";
import { default as permissionsJsGJZ9Gk8p08uICvPDIwcedd63lj0Nt3z3MT25M_453tQMeta } from "/tmp/build_06f73642/pages/app/onboarding/permissions.vue?macro=true";
import { default as onboardingiBRuIsZTWOgn6gTXMuPnjNm_45tTGjzMvFyT3oX8GZQ_45IMeta } from "/tmp/build_06f73642/pages/app/onboarding.vue?macro=true";
import { default as investorsviw6sWtqLsUl5cn2TjYaDdcO_45_W_HpiiQX0tKcB9jwEMeta } from "/tmp/build_06f73642/pages/main/investors.vue?macro=true";
import { default as _91id_93eIAmBGUBb_SYC7t2RwvUTvsAb0enTEn8Tdak_3G9tlMMeta } from "/tmp/build_06f73642/pages/admin/blog/[id].vue?macro=true";
import { default as broadcast9cQZVDDWwxqUD6FxwszPYSUXc1rhp_45jSETFz7ATspoIMeta } from "/tmp/build_06f73642/pages/admin/broadcast.vue?macro=true";
import { default as delete1vWlAckrC5MEwRaM1VlWE3i3xR5uR__vXhu_t6XF7EgMeta } from "/tmp/build_06f73642/pages/app/auth/delete.vue?macro=true";
import { default as logoutPaDj4t7dBYXBqN2ClEntN766Nw3m3xPiWNttovBf9P0Meta } from "/tmp/build_06f73642/pages/app/auth/logout.vue?macro=true";
import { default as indexTzhWt_45NNggrN2iG13Cay1cCdipGO1mApq71nMkiTbPMMeta } from "/tmp/build_06f73642/pages/app/story/index.vue?macro=true";
import { default as indexJpcYFUVyaNUh_OX0zXw8C23cfd3yUvli0_NZF_45bLiPQMeta } from "/tmp/build_06f73642/pages/backstage/index.vue?macro=true";
import { default as indexLygwP1aMiOnpjdaxXKdGNpEeykB9of47jOiqHB7CEEUMeta } from "/tmp/build_06f73642/pages/main/auth/index.vue?macro=true";
import { default as indexFkFOFs77L_WI8sfQTCq_xCRXukA4U48rGmuTWduPE74Meta } from "/tmp/build_06f73642/pages/main/blog/index.vue?macro=true";
import { default as index6x4MU3t2gRD0DqWtBJXrjPawC_OsCu3LeMMJwRJd0nsMeta } from "/tmp/build_06f73642/pages/admin/auth/index.vue?macro=true";
import { default as indexfBwvsUnSyJMfwk6mYF9LIn_45MlEUd9r7DrPwUaH1z1bkMeta } from "/tmp/build_06f73642/pages/admin/blog/index.vue?macro=true";
import { default as deleteg23AdN3LW50RZlprCzrjzikP_XeUfrtjHQhO6Zb7FM0Meta } from "/tmp/build_06f73642/pages/main/auth/delete.vue?macro=true";
import { default as _91slug_93uk3QbhUtfhDRfzRFvP2LVYl2a9kWwGkkC5KaWUZW_98Meta } from "/tmp/build_06f73642/pages/main/blog/[slug].vue?macro=true";
import { default as index2FZVO2t32S5Z5UCryPcg9Rt4feuoX3TrQGgQzZXqicYMeta } from "/tmp/build_06f73642/pages/main/event/index.vue?macro=true";
import { default as _91token_93OG5feDi7lWLxr3yvphTR_45qzLMEMuyldabP1xMK5Tk40Meta } from "/tmp/build_06f73642/pages/payments/[token].vue?macro=true";
import { default as editkQ_8MMVbg4idtRQYDo_fe5LiNB4fC5dGEE7a20V_45dMcMeta } from "/tmp/build_06f73642/pages/app/events/[slug]/edit.vue?macro=true";
import { default as indexJehGKdevhtuKk_8rkFHA4J2LxBSLi2iilWLStkCS3xYMeta } from "/tmp/build_06f73642/pages/app/events/[slug]/index.vue?macro=true";
import { default as _91slug_93bnalzoupBS4EBOPI_45rWgWmzD4Zh5SCXKCKHQIX52aDIMeta } from "/tmp/build_06f73642/pages/app/events/[slug].vue?macro=true";
import { default as createafYdjYw9qjSFGAtuCF5y5RHQSiQwdMyb_lKOqvXQiKgMeta } from "/tmp/build_06f73642/pages/app/events/create.vue?macro=true";
import { default as listoOcBttVFhF1WyUPxeilbupOAWFSqO_45_45ndYlUq5vxGToMeta } from "/tmp/build_06f73642/pages/app/partners/list.vue?macro=true";
import { default as _91slug_93mudmNgNfaG_5sxvtaJMHllnrLuvlGxecEca50kh8c4sMeta } from "/tmp/build_06f73642/pages/main/event/[slug].vue?macro=true";
import { default as _91slug_93tiPFavq_AQM0wvwBfKrZefaYmOTJqUjDuUQpwc6xuegMeta } from "/tmp/build_06f73642/pages/main/group/[slug].vue?macro=true";
import { default as _91slug_93WMu7nScuR8KfNuGZafGyopncOhedRCbwDjmToRsK_45a8Meta } from "/tmp/build_06f73642/pages/main/place/[slug].vue?macro=true";
import { default as _91city_93t5aleXpxnLTgGXlkEq0UFpW_PKyQXq8PJCgHWqzbqsoMeta } from "/tmp/build_06f73642/pages/main/cities/[city].vue?macro=true";
import { default as _91slug_93dg_Vl4hklEd1gk_60CBd61oBXrr5cdE1aZGLfBF9_nEMeta } from "/tmp/build_06f73642/pages/main/invite/[slug].vue?macro=true";
import { default as organizationshbSVba1GPpI_iTl2xIChmuUotP_QOjLi9_mScWnjY9sMeta } from "/tmp/build_06f73642/pages/admin/organizations.vue?macro=true";
import { default as indexYXA0Qq79fq9MQVUdsjqP5PXYNRalBm1HWL8ImsWnoEEMeta } from "/tmp/build_06f73642/pages/admin/reports/index.vue?macro=true";
import { default as eventssYsAdoVLtnz0VjCAN_45w7PpEhXR1l9jo_45EFAD0DQ7xygMeta } from "/tmp/build_06f73642/pages/admin/reports/events.vue?macro=true";
import { default as preferencesuyFOyutSsLCh8RsU_oLEZmqvlLo2lx_tflVLsDe598EMeta } from "/tmp/build_06f73642/pages/app/auth/preferences.vue?macro=true";
import { default as loginB5uh_45fskhoZmZrqU_45CSY3xx_drksR3VcnczIHMmqvWkMeta } from "/tmp/build_06f73642/pages/backstage/auth/login.vue?macro=true";
import { default as _91id_93dV5D_YJQEptNH_NzmaZiGOie_45TtWFiyb13GUAj1gS9kMeta } from "/tmp/build_06f73642/pages/app/conversation/[id].vue?macro=true";
import { default as logoutCo23OTWqz0ssGRjGvNhtV7eY5fEAoTwXbv5STWQ6ZAkMeta } from "/tmp/build_06f73642/pages/backstage/auth/logout.vue?macro=true";
import { default as preferencesLaP528C7Fj_Mb4uvmWTeKDwpNOdzjEE1Gvfm5fTEsacMeta } from "/tmp/build_06f73642/pages/main/auth/preferences.vue?macro=true";
import { default as listfjJmEZF_CI6so0LAeF2YhrM9vVVmh9L6FCKl24xTw9oMeta } from "/tmp/build_06f73642/pages/app/organizations/list.vue?macro=true";
import { default as _91token_93pjD_MsXrfcHw_77s6Rh7f040MnA5chF2DDDg_iV9nvcMeta } from "/tmp/build_06f73642/pages/app/auth/verify/[token].vue?macro=true";
import { default as registerKDLEPuwfSnUPRHyIuKGqIMk82m4_hrEN4TM7l9v_USIMeta } from "/tmp/build_06f73642/pages/backstage/auth/register.vue?macro=true";
import { default as _91code_93lO9QljJ_RW8JZqEaqY4o3DsSSISUMJiXZxdNyJS_45IRQMeta } from "/tmp/build_06f73642/pages/backstage/invite/[code].vue?macro=true";
import { default as discordQnX9jhIQQUc8Igp8nKfFnVqHpSECiI8I5cNUJMDx18IMeta } from "/tmp/build_06f73642/pages/app/integrations/discord.vue?macro=true";
import { default as indexjX0rpKM5BJ19ZomxdUJ9wngRO6G25DH6A68DlVeLSk8Meta } from "/tmp/build_06f73642/pages/backstage/dashboard/index.vue?macro=true";
import { default as questions_45frequenteslAxwS9jbIBXLPFKMczPMg6ebXMTyas0naAV_VUEMZ8IMeta } from "/tmp/build_06f73642/pages/main/questions-frequentes.vue?macro=true";
import { default as discord_45authNb_cpczd_45Gq9I8VxWbINdJS_45EGNwOAyFtbxRpKv5Un8Meta } from "/tmp/build_06f73642/pages/app/integrations/discord-auth.vue?macro=true";
import { default as subscribeTTyAwbMK7frizDYqXnX_zeq0lpq3san6Z5_45LIgkeXC4Meta } from "/tmp/build_06f73642/pages/backstage/dashboard/subscribe.vue?macro=true";
import { default as indexs2YOzy_65CBVEON_45OWPu9iDLc9vXAZc1Dv1JJwYmcHwMeta } from "/tmp/build_06f73642/pages/backstage/dashboard/events/index.vue?macro=true";
import { default as index4IYW5T51_45Cb9kULZRWR_45_45yzkWIzlZCWQk_zo2bejR5EMeta } from "/tmp/build_06f73642/pages/backstage/dashboard/places/index.vue?macro=true";
import { default as indexHNzn7Yi7NKB4s_i10RiLDqnmXJX_oh9_mMHFkRlaGS4Meta } from "/tmp/build_06f73642/pages/backstage/dashboard/events/[slug]/edit/index.vue?macro=true";
import { default as detailsFaDh4EiVBeQvCYvDAEy9gbMisPxQNvTmKWU2Ng8OctAMeta } from "/tmp/build_06f73642/pages/backstage/dashboard/events/[slug]/edit/details.vue?macro=true";
import { default as advancedJ_Li8X6TKtUlq4z_45p2V4oI8io2yb6PYnGt_45WdkvLz_sMeta } from "/tmp/build_06f73642/pages/backstage/dashboard/events/[slug]/edit/advanced.vue?macro=true";
import { default as attendees0mZXQe2XHoCVtc8gx5rw9d9JcTOMyrSyti2iMi4R3FUMeta } from "/tmp/build_06f73642/pages/backstage/dashboard/events/[slug]/edit/attendees.vue?macro=true";
import { default as editS8hRk0lWakJ47TA_45vYJve2CbE1BthdyB9DPrItFOWwwMeta } from "/tmp/build_06f73642/pages/backstage/dashboard/events/[slug]/edit.vue?macro=true";
import { default as index9vzRdHUygS1qCLIn5Di07M7ua2bYUhXwVqkYq9nChKwMeta } from "/tmp/build_06f73642/pages/backstage/dashboard/events/[slug]/index.vue?macro=true";
import { default as attendeesxHoT5NOlODHVL3WeK87_ggzP9Wo7u1sPViujZFIHnGwMeta } from "/tmp/build_06f73642/pages/backstage/dashboard/events/[slug]/attendees.vue?macro=true";
import { default as _91slug_93Ilg2yhlotKvWhYzyuBrWrqWyofH49zwVeOyCGsASDYUMeta } from "/tmp/build_06f73642/pages/backstage/dashboard/events/[slug].vue?macro=true";
import { default as createzaVTXpDw2bS0_456xehsQrM5NBss4rJPGAqNVd0_MQr4IMeta } from "/tmp/build_06f73642/pages/backstage/dashboard/events/create.vue?macro=true";
import { default as index8EUleSoWkE8gW0ItKIwZkczKrexOtSKf19bt_luL0kwMeta } from "/tmp/build_06f73642/pages/backstage/dashboard/settings/index.vue?macro=true";
import { default as indexvQMhUgk1xrgQcg0oCpDMZcZ_45jADqxyTZ6CP4BfDdiXoMeta } from "/tmp/build_06f73642/pages/backstage/dashboard/organization/index.vue?macro=true";
import { default as component_45stub9_mKCaRS85erXtqEmaGHcCQHosth8lMYu9izqT7fsDoMeta } from "/tmp/build_06f73642/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stub9_mKCaRS85erXtqEmaGHcCQHosth8lMYu9izqT7fsDo } from "/tmp/build_06f73642/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: meMnIRIgDOyfv4Vl_45xnq7ge7LcemoYbs7jC0JdbKp4XgAMeta?.name,
    path: "/app/me",
    meta: meMnIRIgDOyfv4Vl_45xnq7ge7LcemoYbs7jC0JdbKp4XgAMeta || {},
    component: () => import("/tmp/build_06f73642/pages/app/me.vue"),
    children: [
  {
    name: "app-me",
    path: "",
    component: () => import("/tmp/build_06f73642/pages/app/me/index.vue")
  }
]
  },
  {
    name: "app-map",
    path: "/app/map",
    meta: { ...(map5_b8grYcoPL0Fhwq04qPekM_452NgoNkwDU9o8HEhazlYMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_06f73642/pages/app/map.vue")
  },
  {
    name: feedlHMSRfntoBj_456YywSKFYPAT65Dw3nRfaJF0f0t2S_45KcMeta?.name,
    path: "/app/feed",
    meta: { ...(feedlHMSRfntoBj_456YywSKFYPAT65Dw3nRfaJF0f0t2S_45KcMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_06f73642/pages/app/feed.vue"),
    children: [
  {
    name: "app-feed-post",
    path: "post",
    meta: postaB85D2X8NtaasB6Q7srufyqj8yTy9bL_455vInW6WFAR0Meta || {},
    component: () => import("/tmp/build_06f73642/pages/app/feed/post.vue")
  },
  {
    name: "app-feed",
    path: "",
    meta: indexzFxvZtqgRBWY_45DQwTeL1rtq4VOc0FesXGRStyh6qM8MMeta || {},
    component: () => import("/tmp/build_06f73642/pages/app/feed/index.vue")
  },
  {
    name: "app-feed-type",
    path: ":type()",
    meta: _91type_93vyHbFrrY_45OZHS23N_PCADcZwUwvx3jz0_hHPZq_45GekoMeta || {},
    component: () => import("/tmp/build_06f73642/pages/app/feed/[type].vue")
  }
]
  },
  {
    name: "app",
    path: "/app",
    meta: { ...(indexPBpwQqiIqihhOm_45OMgLYmVkBjt5SO_MGI8wbY3j4d8MMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_06f73642/pages/app/index.vue")
  },
  {
    name: "main-eula",
    path: "/main/eula",
    meta: eulaeSOwiwjIGA9RRIEsjejrgt3Hc3pu4E6hqlNbIKt2dgIMeta || {},
    component: () => import("/tmp/build_06f73642/pages/main/eula.vue")
  },
  {
    name: groups4ob2JaLhRrU3m4NwzWrKZEYzqgiLMCfQPzeDUKDgNfcMeta?.name,
    path: "/app/groups",
    meta: { ...(groups4ob2JaLhRrU3m4NwzWrKZEYzqgiLMCfQPzeDUKDgNfcMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_06f73642/pages/app/groups.vue"),
    children: [
  {
    name: "app-groups",
    path: "",
    component: () => import("/tmp/build_06f73642/pages/app/groups/index.vue")
  },
  {
    name: _91slug_93oRdGCQLztwxnBecm9XMlV7tC3LR4g9Vvr_45Gw5FnioagMeta?.name,
    path: ":slug()",
    meta: _91slug_93oRdGCQLztwxnBecm9XMlV7tC3LR4g9Vvr_45Gw5FnioagMeta || {},
    component: () => import("/tmp/build_06f73642/pages/app/groups/[slug].vue"),
    children: [
  {
    name: "app-groups-slug-edit",
    path: "edit",
    component: () => import("/tmp/build_06f73642/pages/app/groups/[slug]/edit.vue")
  },
  {
    name: "app-groups-slug-about",
    path: "about",
    component: () => import("/tmp/build_06f73642/pages/app/groups/[slug]/about.vue")
  },
  {
    name: "app-groups-slug",
    path: "",
    component: () => import("/tmp/build_06f73642/pages/app/groups/[slug]/index.vue")
  },
  {
    name: "app-groups-slug-events",
    path: "events",
    component: () => import("/tmp/build_06f73642/pages/app/groups/[slug]/events.vue")
  },
  {
    name: "app-groups-slug-members",
    path: "members",
    component: () => import("/tmp/build_06f73642/pages/app/groups/[slug]/members.vue")
  },
  {
    name: "app-groups-slug-conversations",
    path: "conversations",
    component: () => import("/tmp/build_06f73642/pages/app/groups/[slug]/conversations.vue")
  }
]
  },
  {
    name: "app-groups-create",
    path: "create",
    meta: createx_45QlrnCTOJgO5ZXs7nxbZdzpsXeyGCdhknJAT2wSy2kMeta || {},
    component: () => import("/tmp/build_06f73642/pages/app/groups/create.vue")
  }
]
  },
  {
    name: paramslpxSzEsWMe_450fJbQxK_tuGydBUct4iKhFfOAcVEKBpQMeta?.name,
    path: "/app/params",
    meta: { ...(paramslpxSzEsWMe_450fJbQxK_tuGydBUct4iKhFfOAcVEKBpQMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_06f73642/pages/app/params.vue"),
    children: [
  {
    name: "app-params",
    path: "",
    meta: { ...(indext_4dnXTLqqGcpCLEHOAglsS3SQoHsnETptG_KmQI1_cMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_06f73642/pages/app/params/index.vue")
  },
  {
    name: "app-params-account",
    path: "account",
    meta: { ...(accountWIlQ_9TKL12AKUxsaLAZkBXShOigbgAYoq0UEL7oqlYMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_06f73642/pages/app/params/account.vue")
  },
  {
    name: "app-params-transactions",
    path: "transactions",
    meta: { ...(transactionsg7LuREdwi1yH4oX0S_45MllPwUaG5Lja610gvo161ZkIAMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_06f73642/pages/app/params/transactions.vue")
  }
]
  },
  {
    name: "main",
    path: "/main",
    meta: indexrMNJ7O08o4K0grJ6_45zfuym5WiTaN1GoP3k5gvIhXjKUMeta || {},
    component: () => import("/tmp/build_06f73642/pages/main/index.vue")
  },
  {
    name: "main-press",
    path: "/main/press",
    meta: pressF76SmTrnWrU3PPCv8ir_45qu1P8x9rpcePAn5G8dE4tYYMeta || {},
    component: () => import("/tmp/build_06f73642/pages/main/press.vue")
  },
  {
    name: "admin-codes",
    path: "/admin/codes",
    meta: { ...(codesSvWMc3jTgLL21N5lcW_45QaIMSRst_J4QyuSciYu98_45DoMeta || {}), ...{"middleware":["is-admin"]} },
    component: () => import("/tmp/build_06f73642/pages/admin/codes.vue")
  },
  {
    name: "admin",
    path: "/admin",
    meta: { ...(indexfItK3PYyGYWyyqNmTRpnMoqkp8JysIgmu9_45N8SklnRwMeta || {}), ...{"middleware":["is-admin"]} },
    component: () => import("/tmp/build_06f73642/pages/admin/index.vue")
  },
  {
    name: hangoutSHV0q_45qHoJKnAgDBfxJkcT6lF4fbGbWVpfbh_zhDnCoMeta?.name,
    path: "/app/hangout",
    meta: { ...(hangoutSHV0q_45qHoJKnAgDBfxJkcT6lF4fbGbWVpfbh_zhDnCoMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_06f73642/pages/app/hangout.vue"),
    children: [
  {
    name: "app-hangout",
    path: "",
    meta: indexvQp6R9J5RRYKoiiSXHlSG7NgMjac2GGwYR5Bqetcy6kMeta || {},
    component: () => import("/tmp/build_06f73642/pages/app/hangout/index.vue")
  },
  {
    name: "app-hangout-agenda",
    path: "agenda",
    meta: { ...(agendaqXFkiLTCqtyccP1SZGhmJNmLhL5By2Z_ofswMFNoriYMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_06f73642/pages/app/hangout/agenda.vue")
  },
  {
    name: "app-hangout-meetups",
    path: "meetups",
    meta: meetupstULUCr06DXu1H6Oo4xERo9fAV7CPuaNR6nvl4PiOcZwMeta || {},
    component: () => import("/tmp/build_06f73642/pages/app/hangout/meetups.vue")
  },
  {
    name: "app-hangout-organize",
    path: "organize",
    meta: { ...(organizePP3XsxgSnm87UcePbTx4FdKilQVWIlv9OwQXmsrnNqAMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_06f73642/pages/app/hangout/organize.vue")
  }
]
  },
  {
    name: "main-charte",
    path: "/main/charte",
    meta: charteLudSdpnZFgIYPS1OcxrmMPZYYIUXXqDQvDQ2fKSzbbIMeta || {},
    component: () => import("/tmp/build_06f73642/pages/main/charte.vue")
  },
  {
    name: "main-france",
    path: "/main/france",
    meta: francepCdqAsrhUFZ3RcM6gqoXONgX_sC0WQdmaTxZgw34pCwMeta || {},
    component: () => import("/tmp/build_06f73642/pages/main/france.vue")
  },
  {
    name: "admin-themes",
    path: "/admin/themes",
    meta: { ...(themesa0UtoVFiH7kaHFZDwoz1_zWCwobssx9PVz_45inAGsSPIMeta || {}), ...{"middleware":["is-admin"]} },
    component: () => import("/tmp/build_06f73642/pages/admin/themes.vue")
  },
  {
    name: insidersKL_45MMN1kj5r02eYmpifuQbArSiIysoFaY3GoQR6rQogMeta?.name,
    path: "/app/insiders",
    meta: { ...(insidersKL_45MMN1kj5r02eYmpifuQbArSiIysoFaY3GoQR6rQogMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_06f73642/pages/app/insiders.vue"),
    children: [
  {
    name: "app-insiders",
    path: "",
    component: () => import("/tmp/build_06f73642/pages/app/insiders/index.vue")
  },
  {
    name: "app-insiders-suggestions",
    path: "suggestions",
    meta: suggestionsHPYTd08S5qHGG3xoeY_45OpEqLjg6Ns1BIvTQya01k2wIMeta || {},
    component: () => import("/tmp/build_06f73642/pages/app/insiders/suggestions.vue")
  }
]
  },
  {
    name: "app-messages",
    path: "/app/messages",
    meta: { ...(messagesJ1TK2biZX_45q2hjzGH7znPd0IsyB1H_4552_45rxSVintGkUMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_06f73642/pages/app/messages.vue")
  },
  {
    name: "main-privacy",
    path: "/main/privacy",
    meta: privacytm2SObd_bWtwmDzNeniGftpS8b3LCR7q8HRRLk4UsPoMeta || {},
    component: () => import("/tmp/build_06f73642/pages/main/privacy.vue")
  },
  {
    name: "admin-trainer",
    path: "/admin/trainer",
    meta: { ...(trainerl4oxkpqQAP1o4QGh7CLplUNdxJzv0G06Kh_45k3YF0a40Meta || {}), ...{"middleware":["is-admin"]} },
    component: () => import("/tmp/build_06f73642/pages/admin/trainer.vue")
  },
  {
    name: communityt7ILxyDDMo82dEukd9JfSdAt_A9UJxEJVxD0CocHw3IMeta?.name,
    path: "/app/community",
    meta: { ...(communityt7ILxyDDMo82dEukd9JfSdAt_A9UJxEJVxD0CocHw3IMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_06f73642/pages/app/community.vue"),
    children: [
  {
    name: "app-community",
    path: "",
    meta: indexThqkcQxwZiG8A5wpaDO2qMIQ2xsr81UR9zdGefBoAGsMeta || {},
    component: () => import("/tmp/build_06f73642/pages/app/community/index.vue")
  },
  {
    name: "app-community-search",
    path: "search",
    meta: searchxSwYH92gkz1ZJbleh6oc7zMreDCNaqFLCVMn0mzt2MgMeta || {},
    component: () => import("/tmp/build_06f73642/pages/app/community/search.vue")
  },
  {
    name: "app-community-besties",
    path: "besties",
    meta: { ...(bestiesRRS8RQSGq9UydhJPWsjbwVH_nhL3kIpU1JK0y3gjrisMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_06f73642/pages/app/community/besties.vue")
  },
  {
    name: "app-community-type",
    path: ":type()",
    meta: { ...(indexU3UXnFeB58LGqGY2j8XDGHvgOHt453OMFIwEarNHNFcMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_06f73642/pages/app/community/[type]/index.vue")
  }
]
  },
  {
    name: "app-auth",
    path: "/app/auth",
    meta: { ...(index_3cNWQzr3Ex6Gbo3DxNXIH03KUxg77Qo1pwcCvU_9GoMeta || {}), ...{"middleware":["is-not-user"]} },
    component: () => import("/tmp/build_06f73642/pages/app/auth/index.vue")
  },
  {
    name: onboardingiBRuIsZTWOgn6gTXMuPnjNm_45tTGjzMvFyT3oX8GZQ_45IMeta?.name,
    path: "/app/onboarding",
    meta: { ...(onboardingiBRuIsZTWOgn6gTXMuPnjNm_45tTGjzMvFyT3oX8GZQ_45IMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_06f73642/pages/app/onboarding.vue"),
    children: [
  {
    name: "app-onboarding-about",
    path: "about",
    component: () => import("/tmp/build_06f73642/pages/app/onboarding/about.vue")
  },
  {
    name: "app-onboarding-email",
    path: "email",
    component: () => import("/tmp/build_06f73642/pages/app/onboarding/email.vue")
  },
  {
    name: "app-onboarding-goals",
    path: "goals",
    component: () => import("/tmp/build_06f73642/pages/app/onboarding/goals.vue")
  },
  {
    name: "app-onboarding",
    path: "",
    meta: indexAasrqmQ0roI14GVdJhu4jZhf_6w5R_45a9RwBpvtIYjecMeta || {},
    component: () => import("/tmp/build_06f73642/pages/app/onboarding/index.vue")
  },
  {
    name: "app-onboarding-phone",
    path: "phone",
    component: () => import("/tmp/build_06f73642/pages/app/onboarding/phone.vue")
  },
  {
    name: "app-onboarding-groups",
    path: "groups",
    component: () => import("/tmp/build_06f73642/pages/app/onboarding/groups.vue")
  },
  {
    name: "app-onboarding-search",
    path: "search",
    component: () => import("/tmp/build_06f73642/pages/app/onboarding/search.vue")
  },
  {
    name: "app-onboarding-charter",
    path: "charter",
    component: () => import("/tmp/build_06f73642/pages/app/onboarding/charter.vue")
  },
  {
    name: "app-onboarding-loading",
    path: "loading",
    component: () => import("/tmp/build_06f73642/pages/app/onboarding/loading.vue")
  },
  {
    name: "app-onboarding-profile",
    path: "profile",
    component: () => import("/tmp/build_06f73642/pages/app/onboarding/profile.vue")
  },
  {
    name: "app-onboarding-identity",
    path: "identity",
    component: () => import("/tmp/build_06f73642/pages/app/onboarding/identity.vue")
  },
  {
    name: "app-onboarding-profiles",
    path: "profiles",
    component: () => import("/tmp/build_06f73642/pages/app/onboarding/profiles.vue")
  },
  {
    name: "app-onboarding-membership",
    path: "membership",
    component: () => import("/tmp/build_06f73642/pages/app/onboarding/membership.vue")
  },
  {
    name: "app-onboarding-permissions",
    path: "permissions",
    component: () => import("/tmp/build_06f73642/pages/app/onboarding/permissions.vue")
  }
]
  },
  {
    name: "main-investors",
    path: "/main/investors",
    meta: investorsviw6sWtqLsUl5cn2TjYaDdcO_45_W_HpiiQX0tKcB9jwEMeta || {},
    component: () => import("/tmp/build_06f73642/pages/main/investors.vue")
  },
  {
    name: "admin-blog-id",
    path: "/admin/blog/:id()",
    meta: { ...(_91id_93eIAmBGUBb_SYC7t2RwvUTvsAb0enTEn8Tdak_3G9tlMMeta || {}), ...{"middleware":["is-admin"]} },
    component: () => import("/tmp/build_06f73642/pages/admin/blog/[id].vue")
  },
  {
    name: "admin-broadcast",
    path: "/admin/broadcast",
    meta: { ...(broadcast9cQZVDDWwxqUD6FxwszPYSUXc1rhp_45jSETFz7ATspoIMeta || {}), ...{"middleware":["is-admin"]} },
    component: () => import("/tmp/build_06f73642/pages/admin/broadcast.vue")
  },
  {
    name: "app-auth-delete",
    path: "/app/auth/delete",
    meta: delete1vWlAckrC5MEwRaM1VlWE3i3xR5uR__vXhu_t6XF7EgMeta || {},
    component: () => import("/tmp/build_06f73642/pages/app/auth/delete.vue")
  },
  {
    name: "app-auth-logout",
    path: "/app/auth/logout",
    meta: logoutPaDj4t7dBYXBqN2ClEntN766Nw3m3xPiWNttovBf9P0Meta || {},
    component: () => import("/tmp/build_06f73642/pages/app/auth/logout.vue")
  },
  {
    name: "app-story",
    path: "/app/story",
    meta: { ...(indexTzhWt_45NNggrN2iG13Cay1cCdipGO1mApq71nMkiTbPMMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_06f73642/pages/app/story/index.vue")
  },
  {
    name: "backstage",
    path: "/backstage",
    meta: { ...(indexJpcYFUVyaNUh_OX0zXw8C23cfd3yUvli0_NZF_45bLiPQMeta || {}), ...{"middleware":["backstage-auth"]} },
    component: () => import("/tmp/build_06f73642/pages/backstage/index.vue")
  },
  {
    name: "main-auth",
    path: "/main/auth",
    component: () => import("/tmp/build_06f73642/pages/main/auth/index.vue")
  },
  {
    name: "main-blog",
    path: "/main/blog",
    meta: indexFkFOFs77L_WI8sfQTCq_xCRXukA4U48rGmuTWduPE74Meta || {},
    component: () => import("/tmp/build_06f73642/pages/main/blog/index.vue")
  },
  {
    name: "admin-auth",
    path: "/admin/auth",
    meta: index6x4MU3t2gRD0DqWtBJXrjPawC_OsCu3LeMMJwRJd0nsMeta || {},
    component: () => import("/tmp/build_06f73642/pages/admin/auth/index.vue")
  },
  {
    name: "admin-blog",
    path: "/admin/blog",
    meta: { ...(indexfBwvsUnSyJMfwk6mYF9LIn_45MlEUd9r7DrPwUaH1z1bkMeta || {}), ...{"middleware":["is-admin"]} },
    component: () => import("/tmp/build_06f73642/pages/admin/blog/index.vue")
  },
  {
    name: "main-auth-delete",
    path: "/main/auth/delete",
    component: () => import("/tmp/build_06f73642/pages/main/auth/delete.vue")
  },
  {
    name: "main-blog-slug",
    path: "/main/blog/:slug()",
    meta: _91slug_93uk3QbhUtfhDRfzRFvP2LVYl2a9kWwGkkC5KaWUZW_98Meta || {},
    component: () => import("/tmp/build_06f73642/pages/main/blog/[slug].vue")
  },
  {
    name: "main-event",
    path: "/main/event",
    meta: index2FZVO2t32S5Z5UCryPcg9Rt4feuoX3TrQGgQzZXqicYMeta || {},
    component: () => import("/tmp/build_06f73642/pages/main/event/index.vue")
  },
  {
    name: "payments-token",
    path: "/payments/:token()",
    meta: _91token_93OG5feDi7lWLxr3yvphTR_45qzLMEMuyldabP1xMK5Tk40Meta || {},
    component: () => import("/tmp/build_06f73642/pages/payments/[token].vue")
  },
  {
    name: _91slug_93bnalzoupBS4EBOPI_45rWgWmzD4Zh5SCXKCKHQIX52aDIMeta?.name,
    path: "/app/events/:slug()",
    meta: { ...(_91slug_93bnalzoupBS4EBOPI_45rWgWmzD4Zh5SCXKCKHQIX52aDIMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_06f73642/pages/app/events/[slug].vue"),
    children: [
  {
    name: "app-events-slug-edit",
    path: "edit",
    meta: editkQ_8MMVbg4idtRQYDo_fe5LiNB4fC5dGEE7a20V_45dMcMeta || {},
    component: () => import("/tmp/build_06f73642/pages/app/events/[slug]/edit.vue")
  },
  {
    name: "app-events-slug",
    path: "",
    component: () => import("/tmp/build_06f73642/pages/app/events/[slug]/index.vue")
  }
]
  },
  {
    name: "app-events-create",
    path: "/app/events/create",
    meta: { ...(createafYdjYw9qjSFGAtuCF5y5RHQSiQwdMyb_lKOqvXQiKgMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_06f73642/pages/app/events/create.vue")
  },
  {
    name: "app-partners-list",
    path: "/app/partners/list",
    meta: { ...(listoOcBttVFhF1WyUPxeilbupOAWFSqO_45_45ndYlUq5vxGToMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_06f73642/pages/app/partners/list.vue")
  },
  {
    name: "main-event-slug",
    path: "/main/event/:slug()",
    meta: _91slug_93mudmNgNfaG_5sxvtaJMHllnrLuvlGxecEca50kh8c4sMeta || {},
    component: () => import("/tmp/build_06f73642/pages/main/event/[slug].vue")
  },
  {
    name: "main-group-slug",
    path: "/main/group/:slug()",
    meta: _91slug_93tiPFavq_AQM0wvwBfKrZefaYmOTJqUjDuUQpwc6xuegMeta || {},
    component: () => import("/tmp/build_06f73642/pages/main/group/[slug].vue")
  },
  {
    name: "main-place-slug",
    path: "/main/place/:slug()",
    meta: _91slug_93WMu7nScuR8KfNuGZafGyopncOhedRCbwDjmToRsK_45a8Meta || {},
    component: () => import("/tmp/build_06f73642/pages/main/place/[slug].vue")
  },
  {
    name: "main-cities-city",
    path: "/main/cities/:city()",
    meta: _91city_93t5aleXpxnLTgGXlkEq0UFpW_PKyQXq8PJCgHWqzbqsoMeta || {},
    component: () => import("/tmp/build_06f73642/pages/main/cities/[city].vue")
  },
  {
    name: "main-invite-slug",
    path: "/main/invite/:slug()",
    component: () => import("/tmp/build_06f73642/pages/main/invite/[slug].vue")
  },
  {
    name: "admin-organizations",
    path: "/admin/organizations",
    meta: { ...(organizationshbSVba1GPpI_iTl2xIChmuUotP_QOjLi9_mScWnjY9sMeta || {}), ...{"middleware":["is-admin"]} },
    component: () => import("/tmp/build_06f73642/pages/admin/organizations.vue")
  },
  {
    name: "admin-reports",
    path: "/admin/reports",
    meta: { ...(indexYXA0Qq79fq9MQVUdsjqP5PXYNRalBm1HWL8ImsWnoEEMeta || {}), ...{"middleware":["is-admin"]} },
    component: () => import("/tmp/build_06f73642/pages/admin/reports/index.vue")
  },
  {
    name: "admin-reports-events",
    path: "/admin/reports/events",
    meta: { ...(eventssYsAdoVLtnz0VjCAN_45w7PpEhXR1l9jo_45EFAD0DQ7xygMeta || {}), ...{"middleware":["is-admin"]} },
    component: () => import("/tmp/build_06f73642/pages/admin/reports/events.vue")
  },
  {
    name: "app-auth-preferences",
    path: "/app/auth/preferences",
    meta: preferencesuyFOyutSsLCh8RsU_oLEZmqvlLo2lx_tflVLsDe598EMeta || {},
    component: () => import("/tmp/build_06f73642/pages/app/auth/preferences.vue")
  },
  {
    name: "backstage-auth-login",
    path: "/backstage/auth/login",
    meta: loginB5uh_45fskhoZmZrqU_45CSY3xx_drksR3VcnczIHMmqvWkMeta || {},
    component: () => import("/tmp/build_06f73642/pages/backstage/auth/login.vue")
  },
  {
    name: "app-conversation-id",
    path: "/app/conversation/:id()",
    meta: { ...(_91id_93dV5D_YJQEptNH_NzmaZiGOie_45TtWFiyb13GUAj1gS9kMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_06f73642/pages/app/conversation/[id].vue")
  },
  {
    name: "backstage-auth-logout",
    path: "/backstage/auth/logout",
    meta: logoutCo23OTWqz0ssGRjGvNhtV7eY5fEAoTwXbv5STWQ6ZAkMeta || {},
    component: () => import("/tmp/build_06f73642/pages/backstage/auth/logout.vue")
  },
  {
    name: "main-auth-preferences",
    path: "/main/auth/preferences",
    component: () => import("/tmp/build_06f73642/pages/main/auth/preferences.vue")
  },
  {
    name: "app-organizations-list",
    path: "/app/organizations/list",
    meta: { ...(listfjJmEZF_CI6so0LAeF2YhrM9vVVmh9L6FCKl24xTw9oMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_06f73642/pages/app/organizations/list.vue")
  },
  {
    name: "app-auth-verify-token",
    path: "/app/auth/verify/:token()",
    meta: _91token_93pjD_MsXrfcHw_77s6Rh7f040MnA5chF2DDDg_iV9nvcMeta || {},
    component: () => import("/tmp/build_06f73642/pages/app/auth/verify/[token].vue")
  },
  {
    name: "backstage-auth-register",
    path: "/backstage/auth/register",
    meta: registerKDLEPuwfSnUPRHyIuKGqIMk82m4_hrEN4TM7l9v_USIMeta || {},
    component: () => import("/tmp/build_06f73642/pages/backstage/auth/register.vue")
  },
  {
    name: "backstage-invite-code",
    path: "/backstage/invite/:code()",
    meta: _91code_93lO9QljJ_RW8JZqEaqY4o3DsSSISUMJiXZxdNyJS_45IRQMeta || {},
    component: () => import("/tmp/build_06f73642/pages/backstage/invite/[code].vue")
  },
  {
    name: "app-integrations-discord",
    path: "/app/integrations/discord",
    meta: discordQnX9jhIQQUc8Igp8nKfFnVqHpSECiI8I5cNUJMDx18IMeta || {},
    component: () => import("/tmp/build_06f73642/pages/app/integrations/discord.vue")
  },
  {
    name: "backstage-dashboard",
    path: "/backstage/dashboard",
    meta: { ...(indexjX0rpKM5BJ19ZomxdUJ9wngRO6G25DH6A68DlVeLSk8Meta || {}), ...{"middleware":["backstage-is-user"]} },
    component: () => import("/tmp/build_06f73642/pages/backstage/dashboard/index.vue")
  },
  {
    name: "main-questions-frequentes",
    path: "/main/questions-frequentes",
    meta: questions_45frequenteslAxwS9jbIBXLPFKMczPMg6ebXMTyas0naAV_VUEMZ8IMeta || {},
    component: () => import("/tmp/build_06f73642/pages/main/questions-frequentes.vue")
  },
  {
    name: "app-integrations-discord-auth",
    path: "/app/integrations/discord-auth",
    meta: discord_45authNb_cpczd_45Gq9I8VxWbINdJS_45EGNwOAyFtbxRpKv5Un8Meta || {},
    component: () => import("/tmp/build_06f73642/pages/app/integrations/discord-auth.vue")
  },
  {
    name: "backstage-dashboard-subscribe",
    path: "/backstage/dashboard/subscribe",
    meta: { ...(subscribeTTyAwbMK7frizDYqXnX_zeq0lpq3san6Z5_45LIgkeXC4Meta || {}), ...{"middleware":["backstage-is-user"]} },
    component: () => import("/tmp/build_06f73642/pages/backstage/dashboard/subscribe.vue")
  },
  {
    name: "backstage-dashboard-events",
    path: "/backstage/dashboard/events",
    meta: { ...(indexs2YOzy_65CBVEON_45OWPu9iDLc9vXAZc1Dv1JJwYmcHwMeta || {}), ...{"middleware":["backstage-is-user"]} },
    component: () => import("/tmp/build_06f73642/pages/backstage/dashboard/events/index.vue")
  },
  {
    name: "backstage-dashboard-places",
    path: "/backstage/dashboard/places",
    meta: { ...(index4IYW5T51_45Cb9kULZRWR_45_45yzkWIzlZCWQk_zo2bejR5EMeta || {}), ...{"middleware":["backstage-is-user"]} },
    component: () => import("/tmp/build_06f73642/pages/backstage/dashboard/places/index.vue")
  },
  {
    name: _91slug_93Ilg2yhlotKvWhYzyuBrWrqWyofH49zwVeOyCGsASDYUMeta?.name,
    path: "/backstage/dashboard/events/:slug()",
    component: () => import("/tmp/build_06f73642/pages/backstage/dashboard/events/[slug].vue"),
    children: [
  {
    name: editS8hRk0lWakJ47TA_45vYJve2CbE1BthdyB9DPrItFOWwwMeta?.name,
    path: "edit",
    meta: { ...(editS8hRk0lWakJ47TA_45vYJve2CbE1BthdyB9DPrItFOWwwMeta || {}), ...{"middleware":["backstage-is-user"]} },
    component: () => import("/tmp/build_06f73642/pages/backstage/dashboard/events/[slug]/edit.vue"),
    children: [
  {
    name: "backstage-dashboard-events-slug-edit",
    path: "",
    component: () => import("/tmp/build_06f73642/pages/backstage/dashboard/events/[slug]/edit/index.vue")
  },
  {
    name: "backstage-dashboard-events-slug-edit-details",
    path: "details",
    component: () => import("/tmp/build_06f73642/pages/backstage/dashboard/events/[slug]/edit/details.vue")
  },
  {
    name: "backstage-dashboard-events-slug-edit-advanced",
    path: "advanced",
    component: () => import("/tmp/build_06f73642/pages/backstage/dashboard/events/[slug]/edit/advanced.vue")
  },
  {
    name: "backstage-dashboard-events-slug-edit-attendees",
    path: "attendees",
    component: () => import("/tmp/build_06f73642/pages/backstage/dashboard/events/[slug]/edit/attendees.vue")
  }
]
  },
  {
    name: "backstage-dashboard-events-slug",
    path: "",
    meta: { ...(index9vzRdHUygS1qCLIn5Di07M7ua2bYUhXwVqkYq9nChKwMeta || {}), ...{"middleware":["backstage-is-user"]} },
    component: () => import("/tmp/build_06f73642/pages/backstage/dashboard/events/[slug]/index.vue")
  },
  {
    name: "backstage-dashboard-events-slug-attendees",
    path: "attendees",
    meta: { ...(attendeesxHoT5NOlODHVL3WeK87_ggzP9Wo7u1sPViujZFIHnGwMeta || {}), ...{"middleware":["backstage-is-user"]} },
    component: () => import("/tmp/build_06f73642/pages/backstage/dashboard/events/[slug]/attendees.vue")
  }
]
  },
  {
    name: "backstage-dashboard-events-create",
    path: "/backstage/dashboard/events/create",
    meta: { ...(createzaVTXpDw2bS0_456xehsQrM5NBss4rJPGAqNVd0_MQr4IMeta || {}), ...{"middleware":["backstage-is-user"]} },
    component: () => import("/tmp/build_06f73642/pages/backstage/dashboard/events/create.vue")
  },
  {
    name: "backstage-dashboard-settings",
    path: "/backstage/dashboard/settings",
    meta: { ...(index8EUleSoWkE8gW0ItKIwZkczKrexOtSKf19bt_luL0kwMeta || {}), ...{"middleware":["backstage-is-user"]} },
    component: () => import("/tmp/build_06f73642/pages/backstage/dashboard/settings/index.vue")
  },
  {
    name: "backstage-dashboard-organization",
    path: "/backstage/dashboard/organization",
    meta: { ...(indexvQMhUgk1xrgQcg0oCpDMZcZ_45jADqxyTZ6CP4BfDdiXoMeta || {}), ...{"middleware":["backstage-is-user"]} },
    component: () => import("/tmp/build_06f73642/pages/backstage/dashboard/organization/index.vue")
  },
  {
    name: component_45stub9_mKCaRS85erXtqEmaGHcCQHosth8lMYu9izqT7fsDoMeta?.name,
    path: "/sitemap.xml",
    component: component_45stub9_mKCaRS85erXtqEmaGHcCQHosth8lMYu9izqT7fsDo
  }
]